// extracted by mini-css-extract-plugin
export default {"container":"DefaultLevel_container__W4Ok8","blockName":"DefaultLevel_blockName__dDeFx"};